import {
  routesForPlanTypeSelector,
  depotSectionsSelector,
  getMatrixProfileMessage,
  wavesListSelector,
} from "../../../reducers/matrixProfile/selectors";

import { InfoMessage } from "../../InfoMessage";
import { RouteDetail } from "../../RouteDetail";
import { SectionMenu } from "..";
import Sections from "../../Sections";
import Waves from "../../Waves";
import { memo } from "react";
import { useSelector } from "react-redux";

export const DefaultSections = memo(() => {
  const message = useSelector(getMatrixProfileMessage);
  const depotSections = useSelector(depotSectionsSelector);
  const wavesList = useSelector(wavesListSelector);
  const routes = useSelector(routesForPlanTypeSelector);

  return (
    <SectionMenu>
      {message && <InfoMessage message={message} />}
      {!message && depotSections && (
        <SectionMenu.SectionMenuItem id={0}>
          <Sections sections={depotSections} />
        </SectionMenu.SectionMenuItem>
      )}
      {!message && routes && (
        <SectionMenu.SectionMenuItem id={1}>
          <RouteDetail routes={routes} />
        </SectionMenu.SectionMenuItem>
      )}
      {!message && wavesList && (
        <SectionMenu.SectionMenuItem id={2}>
          <Waves waves={wavesList} />
        </SectionMenu.SectionMenuItem>
      )}
    </SectionMenu>
  );
});
